import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { ThemedView,ThemedText,ThemedPressable, themeColorSet } from "@app/theme"
import { ScrollView, ImageBackground, Image } from "react-native"
import ClockIcon from "../../../assets/Icons/ClockIcon"
import Button from "@app/sharedComponents/Button/Button"
import {CaretRight} from "@sharedComponents/Icons/index"
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import { useState } from "react"
import HowItWorks from "./components/HowItWorks"
import WhyOpenAcc from "./components/WhyOpenAcc"
import ROUTE from "@app/navigationApp/routes"

const ElevateLanding = ({navigation}) =>{
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [bottomSheetType, setBottomSheetType] = useState(null);

    const openBottomSheet = (type) => {
        setBottomSheetType(type);
        setIsBottomSheetVisible(true);
    };

    const closeBottomSheet = () => {
        setIsBottomSheetVisible(false);
    };
    
    return(
        <>
        <PageHeaders pageName="ElevateLanding" navigation={navigation} />
        <ScrollView style={{ flex: 1 , backgroundColor:themeColorSet["bg-surface-secondary"]}}>
            <ImageBackground 
                style={{ width: "100%", height: 220, alignItems: "center", justifyContent: "flex-end" }} 
                source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_landing_bg.png" }}
                >

                <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_landing_coin.png" }}
                    style={{ width: 130, height: 130 }} />
            </ImageBackground>
            <ThemedText variant="h3s" color="text-primary" textAlign="center" mx="lg" px="lg" >
                    Get an increased limit for zero {'\n'} processing fees
            </ThemedText>
            <ThemedView width={'100%'} height={1} backgroundColor="border-primary" mx="lg" my="md" />
            
            <ThemedView px="lg">
            <ThemedText variant="b3s" color="text-primary" mb="lg">Exclusive benefits</ThemedText>
                <ThemedView flexDirection="row">
                    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                    <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Lightning.png" }} style={{ width: 16, height: 16 }} />
                    </ThemedView>
                    <ThemedView ml="lg" flex={1} flexWrap="wrap">
                        <ThemedText variant="b4s" color="text-primary">Lightning fast withdrawals</ThemedText>
                        <ThemedText variant="b4s" color="text-secondary">Get funds in your account instantly upto 5L and within 2 hours for higher amounts</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView flexDirection="row" py="2xl">
                    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                    <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StackMinus.png"}} style={{ width: 16, height: 16 }} />
                    </ThemedView>
                    <ThemedView ml="lg" flex={1} flexWrap="wrap">
                        <ThemedText variant="b4s" color="text-primary">Seamless asset management</ThemedText>
                        <ThemedText variant="b4s" color="text-secondary">Control the collaterals you want to pledge or 
                        un-pledge in just a click!</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView flexDirection="row" mb="md">
                    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                    <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/0.png"  }} style={{ width: 16, height: 16 }} />
                    </ThemedView>
                    <ThemedView ml="lg" flex={1} flexWrap="wrap">
                        <ThemedText variant="b4s" color="text-primary">Zero processing fees</ThemedText>
                        <ThemedView flexDirection="row" alignItems="center">
                            <ClockIcon/>
                            <ThemedText variant="b4s" color="text-emphasis-secondary"> Limited period offer </ThemedText>
                        </ThemedView>
                    </ThemedView>
                </ThemedView>
            </ThemedView>

            <ThemedView backgroundColor="bg-surface-primary" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary" my="lg">
                <ThemedPressable onPress={()=>openBottomSheet('HOW_IT_WORKS')} px="lg" py="md" flexDirection="row" justifyContent="space-between" alignItems="center" >
                    <ThemedView flexDirection="row" alignItems="center">
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/ChatCircleDots.png" }} style={{ width: 24, height: 24 }} />
                        <ThemedText ml="sm" variant="b4s" color="text-primary">Why open a new loan account?</ThemedText>
                    </ThemedView>
                    <CaretRight/>
                </ThemedPressable>
                <ThemedPressable onPress={()=>openBottomSheet('WHY_OPEN_ACC')}  borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary"
                 px="lg" py="md" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedView flexDirection="row" alignItems="center">
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/howItWorks.png" }} style={{ width: 24, height: 24 }} />
                        <ThemedText ml="sm" variant="b4s" color="text-primary">How it works?</ThemedText>
                    </ThemedView>
                    <CaretRight/>
                </ThemedPressable>
                <ThemedPressable onPress={()=>navigation.navigate(ROUTE.FAQ)} px="lg" py="md" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedView flexDirection="row" alignItems="center">
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/faq.png"}} style={{ width: 24, height: 24 }} />
                        <ThemedText ml="sm" variant="b4s" color="text-primary">FAQ</ThemedText>
                    </ThemedView>
                    <CaretRight/>
                </ThemedPressable>
            </ThemedView>
        </ScrollView>
        <ThemedView  borderTopWidth={1} borderColor="border-primary" p="lg" pt="2xl" backgroundColor="bg-surface-primary">
            <Button label="Check eligibility" handlePress={()=>{}} />
        </ThemedView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containerStyle={{ backgroundColor: '#fefefe' }}
        >
            {bottomSheetType==='HOW_IT_WORKS' && <HowItWorks closeBottomSheet={closeBottomSheet}/>}
            {bottomSheetType==='WHY_OPEN_ACC' && <WhyOpenAcc closeBottomSheet={closeBottomSheet}/>}
        </BottomSheetContainer>
        </>

    )
}

export default ElevateLanding